import { Link } from "react-router-dom";
import SiteFooter from "@/components/feature/SiteFooter";
import SiteHeader from "@/components/feature/SiteHeader";
import { categories, siteName } from "@/mocks/site";

export default function NotFound() {
  return (
    <>
      <title>页面不存在 | {siteName}</title>
      <meta name="robots" content="noindex,follow" />
      <SiteHeader />
      <main className="mx-auto flex max-w-content flex-col items-center justify-center px-4 py-24 text-center md:px-6">
        <span className="flex h-16 w-16 items-center justify-center rounded-md bg-background-100 font-heading text-2xl font-black text-primary-500">
          404
        </span>
        <h1 className="mt-6 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
          这条线索还没被整理出来
        </h1>
        <p className="mt-3 max-w-lg text-sm leading-relaxed text-foreground-600">
          你访问的页面可能已经合并到更新的深扒稿里，或者链接不太对。可以回到首页继续浏览最新爆料，
          也可以按分类找找感兴趣的内容。
        </p>

        <div className="mt-6 flex flex-wrap items-center justify-center gap-3">
          <Link
            to="/"
            className="inline-flex cursor-pointer items-center gap-2 whitespace-nowrap rounded-md bg-foreground-950 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
          >
            <i className="ri-home-4-line"></i>
            返回首页
          </Link>
          <Link
            to="/about"
            className="inline-flex cursor-pointer items-center gap-2 whitespace-nowrap rounded-md border border-background-300 px-5 py-2.5 text-sm text-foreground-800 transition-colors hover:border-primary-300 hover:text-primary-600"
          >
            了解我们
          </Link>
        </div>

        <div className="mt-12 w-full max-w-2xl">
          <p className="text-xs font-medium tracking-[0.2em] text-foreground-500">热门分类</p>
          <div className="mt-4 flex flex-wrap justify-center gap-2">
            {categories.map((item) => (
              <Link
                key={item.slug}
                to={`/?cat=${item.slug}#latest`}
                className="cursor-pointer rounded-md border border-background-300 px-3 py-1.5 text-sm text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-600"
              >
                {item.name}
              </Link>
            ))}
          </div>
        </div>
      </main>
      <SiteFooter />
    </>
  );
}